module.exports = "https://www.gc-pro.gnp.com.mx/66ee2ddb7a072b97957d0c534dc17bee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-2.jpg
// module id = 947
// module chunks = 0 1